import { Button, MessageBar, MessageBarActions, MessageBarBody } from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import parse from 'html-react-parser';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useCommonStyles } from '../../common/hooks';
import { getCleanHtmlString } from '../../common/html-string/get-clean-html-string';
import { NotificationTypeCode } from '../../models';
import './CustomMessageBar.scss';

interface CustomMessageBarProps {
  message: string | React.JSX.Element;
  notificationTypeCode?: NotificationTypeCode;
  showDismissButton?: boolean;
  onDismissClicked?(): void;
}

const CustomMessageBarImpl: React.FC<CustomMessageBarProps> = (props) => {
  const [isHidden, setHidden] = useState(false);
  const commonStyles = useCommonStyles();
  const {
    message,
    notificationTypeCode = 'info',
    showDismissButton,
    onDismissClicked,
  } = props;

  const renderMessage = () => {
    if (typeof message === 'string') {
      return (
        <div className={commonStyles.richTextContent}>
          {parse(getCleanHtmlString(message))}
        </div>
      );
    }
    return message;
  };

  if (isHidden) return null;

  return (
    <MessageBar
      intent={notificationTypeCode}
      className='custom-message-bar'
    >
      <MessageBarBody>
        {renderMessage()}
      </MessageBarBody>
      {
        showDismissButton && (
          <MessageBarActions
            containerAction={
              <Button
                appearance='transparent'
                aria-label='Dismiss'
                icon={<DismissRegular />}
                onClick={() => {
                  setHidden(true);
                  if (onDismissClicked) {
                    onDismissClicked();
                  }
                }}
              />
            }
          />
        )
      }
    </MessageBar>
  );
}

export const CustomMessageBar = observer(CustomMessageBarImpl);
